export default [
    {
        path: 'activeTopic',
        name: 'activeTopic',
        component: (resolve) => require(['@/views/staticModal/activeTopic.vue'], resolve),//更多活动页面
        meta:{
            title:''
        }
    },  
    {
        path: 'prizeActive',
        name: 'prizeActive',
        component: (resolve) => require(['@/views/staticModal/prizeActive'], resolve),//有奖互动页面
        meta:{
            title:''
        }
    },  
    {
        path: 'educationInformation',
        name: 'educationInformation',
        component: (resolve) => require(['@/views/staticModal/educationInformation'], resolve),//学历资讯
        meta:{
            title:''
        }
    },
    {
        path: 'starStudent',
        name: 'starStudent',
        component: (resolve) => require(['@/views/staticModal/starStudent'], resolve),//明星学员页面
        meta:{
            title:''
        }
    },  
    {
        path: 'starTeacher',
        name: 'starTeacher',
        component: (resolve) => require(['@/views/staticModal/starTeacher'], resolve),//明星老师界面
        meta:{
            title:''
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/staticModal.js